export default __webpack_public_path__ + "static/media/ic-estimated-time.c5a905e4.svg";